import { handleDlEvent, hasDlEventAttribute } from "../../common/dl-event-handler.js";

document.addEventListener("copy", trackCopy);

/**
 * Behandelt Copy Events
 * Trackt nur Events mit dl-event Attribut
 */
export function trackCopy(event) {
	const { target } = event;

	// Prüfe ob Element ein dl-event Attribut hat
	if (!hasDlEventAttribute(target)) {
		return;
	}

	// Hole den kopierten Text
	const content = window.getSelection().toString();

	// Behandle dl-event mit content als baseParam
	handleDlEvent(event, { content });
}
